<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="input"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <el-skeleton
          class="width100 backwhite border-rd3"
          :loading="true"
          animated
          :throttle="500"
        >
          <template slot="template">
            <div
              class="
                width100
                backwhite
                pad-bot20
                margin-auto margin-top15
                border-rd3
                alldigital
                pad-top20
              "
              v-if="total != 0"
            >
              <el-table
                :data="page"
                stripe
                style="width: 98%"
                class="eltable margin-auto f14"
              >
                <el-table-column label="政策名称" width="520" align="left"
                  ><template slot-scope="scope">
                    <span
                      @click="previewreport(scope.row)"
                      class="bluecolor overhide cursorpointer"
                      >{{ scope.row.chance.title }}</span
                    ></template
                  ></el-table-column
                >
                <el-table-column label="政策资金" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.chance.money }}万-{{
                      scope.row.chance.max_money
                    }}万
                  </template>
                </el-table-column>
                <el-table-column
                  label="结束时间"
                  align="center"
                  prop="chance.end_time"
                />
                <el-table-column
                  label="分享状态"
                  align="center"
                  prop="chance.company"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.company == undefined || null || ""
                        ? ""
                        : scope.row.company.company
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                  <template slot-scope="scope">
                    <span
                      class="bluecolor cursorpointer"
                      @click="previewreport(scope.row)"
                      >详情</span
                    >
                    <span
                      class="bluecolor cursorpointer pad-left10"
                      @click="homezc(scope.row)"
                      ><span @click="dialogVisibledrawer = true"
                        >分享</span
                      > </span
                    ><span
                      class="bluecolor cursorpointer pad-left10"
                      @click="designDetail(scope.row)"
                      >取消</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div
                class="flex-betweennowrap pad-top20 pad-right10"
                v-if="total != 0"
              >
                <span class="bluecolor"></span>
                <el-pagination
                  :hide-on-single-page="true"
                  @size-change="handleSizeChange"
                  @current-change="currentchange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30, 40, 50]"
                  :page-size="per_page"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  background
                >
                </el-pagination>
              </div>
            </div>
            <div
              class="width100 margin-auto backgroudFFF margin-top15"
              v-if="total == 0"
            >
              <el-empty
                :image="require('@/assets/barsvg/zwsj@3x.png')"
                :image-size="200"
                description="抱歉，没有搜到您想要的内容"
                class="heightempty"
                ><p style="position: relative; bottom: 60px" class="f14">
                  暂无数据
                </p></el-empty
              >
            </div>
          </template>
        </el-skeleton>
      </template>
    </el-skeleton>

    <el-dialog
      title="请选择企业"
      :visible.sync="dialogVisibledrawer"
      :close-on-click-modal="false"
      :show-close="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="drawerbox"
    >
      <div class="newenterprise">
        <el-input
          placeholder="请输入内容"
          v-model="input3"
          @input="nullsearch"
          class="margin-top20 margin-bot10"
        >
          <el-button
            @click="seachenter"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
      <div class="enterprisebox" @scroll="scrollEvent">
        <div v-for="(item, index) in nullcont" :key="index">
          <div class="coer">
            <el-radio-group v-model="radio" @change="coerchange">
              <el-radio class="lineheight35 pad-left20" :label="index">{{
                item.company
              }}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div class="width96 margin-auto textalign-right">
        <el-button type="primary" @click="Enterprisesharing()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import {
  policymyfollow,
  policyunsubscribe,
  policyshare,
} from "@/api/Center/Center.api";
import { boundEnterprise } from "@/api/personal/personal.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        pipo: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progress: "",
      serchkey: true,
      input: "",
      dialogVisibledrawer: false,
      radio: "",
      input3: "",
      changeid: "",
      zhengcheid: "",
      nullcont: "",
      thisNums: 1,
      page1: [],
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    //滚动条触发事件
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // // 获取企业
        boundEnterprise({ limit: 30, page: ++this.thisNums }).then((res) => {
          if (res.data.code == 200) {
            // this.page = res.data.data.data;
            if (res.data.data.data.length == 0) {
              return;
            } else {
              this.page1 = res.data.data.data;
              this.page1.forEach((i) => {
                this.nullcont.push(i);
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    coerchange(val) {
      this.changeid = this.nullcont[val].ent_id;
    },
    homezc(row) {
      this.zhengcheid = row.id;
    },
    // 共享给企业
    Enterprisesharing(row) {
      policyshare({ id: this.zhengcheid, ent_id: this.changeid }).then(
        (res) => {
          if (res.data.code == 200) {
            this.drawer = false;
            this.$message({
              showClose: true,
              message: "已共享",
              type: "success",
            });
            this.refresh();
            this.dialogVisibledrawer = false;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    submitForm() {
      if (this.input != "") {
        policymyfollow({
          _keyword: this.input,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.drawer = false;
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 查看详情
    previewreport(row) {
      window.sessionStorage.setItem("policydetailid", row.chance.id);
      this.$router.push({
        path: "/Science-technology/Policyitems-details",
      });
    },
    // 取消订阅
    designDetail(row) {
      this.$confirm("此操作将取消订阅, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          policyunsubscribe({ id: row.chance.id }).then((res) => {
            if (res.data.code == 200) {
              if (res.data.code == 200) {
                this.drawer = false;
                this.$message({
                  showClose: true,
                  message: "取消订阅成功",
                  type: "success",
                });
                this.refresh();
              }
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 第一个分页
    currentchange(val) {
      policymyfollow({
        page: val,
        _keyword: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      policymyfollow({
        page: 1,
        limit: val,
        _keyword: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      policymyfollow({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    seachenter() {
      boundEnterprise({ _keywords: this.input3 }).then((res) => {
        if (res.data.code == 200) {
          this.nullcont = res.data.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    nullsearch() {
      if (
        this.input3 == null ||
        this.input3 == "" ||
        this.input3 == undefined
      ) {
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.nullcont = res.data.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    refresh() {
      this.$loading.show(); // 显示loading
      policymyfollow({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });

      // // 获取企业
      boundEnterprise().then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.nullcont = res.data.data.data;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("navigetionval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("navigetionval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("navigetionval")
      );
    }

    policymyfollow({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    // // 获取企业
    boundEnterprise().then((res) => {
      if (res.data.code == 200) {
        this.nullcont = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
  <style scoped>
.newenterprise {
  width: 96%;
  margin: auto;
}

.enterprisebox {
  /* border-top: 1px solid #efefef; */
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
/* 隐藏滚动条 */
/* .enterprisebox::-webkit-scrollbar {
  width: 0 !important;
} */

.coer {
  width: 15px;
}

.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.drawerbox >>> .el-dialog__body {
  padding: 0 0 20px 0;
}
.drawerbox >>> .el-dialog__header {
  padding: 10px 0 10px 20px;
  border-bottom: 1px solid #efefef;
  font-size: 16px;
}
.drawerbox >>> .el-dialog__title {
  font-size: 16px;
  color: #606266;
}
</style>